import classNames from "classnames";
import React from "react";
import { useSelector } from "react-redux";

import ModalsComponent from "../modals/modals.component";

import styles from "./main.module.scss";
import LeftColumnComponent from "./left-column/left-column.component";
import RightColumnComponent from "./right-column/right-column.component";

import { ApplicationStore } from "~/app/application.store";

const MainPageComponent: React.FC = () => {
  const selectChatId: string | null = useSelector((state: ApplicationStore) => state.chats.selectChatId);

  return (
    <>
      <div className={classNames(styles.MainPage, selectChatId !== null ? styles.selectChat : "")}>
        <LeftColumnComponent />
        <RightColumnComponent />
      </div>
      <ModalsComponent />
    </>
  );
};

export default MainPageComponent;
